// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewChild, ViewRef, ElementRef, HostListener, Input } from '@angular/core';
// NGRX
// Service
//Models
import { DatePipe } from '@angular/common';
import { FunctionPublic } from 'app/views/pages/nfc/dung-chung/__function/common_function';


@Component({
	selector: 'kt-in-nhap-kho-tu-yeu-cau-171123',
	templateUrl: './in-nhap-kho-tu-yeu-cau-171123.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})


export class NhapKhoTuYeuCau171123PrintComponent implements OnInit {

	@Input() masterData: any;
	@Input() detailData: any[];
	constructor(
		private datePipe: DatePipe) {};
		
	/**
	 * On init
	 */
	departments: string[] = ['QA', 'Kho', 'RD', 'KD B2B', 'KD B2C', 'Marketing', 'Mua hàng', 'Cơ điện', 'BP. Kế toán', 
	'HCNS', 'CNTT', 'Kế hoạch', 'BP. SX- Khu TP rau củ', 'BP.SX- Khu Chế biến', 'BP.SX- Khu TT', 'BP.SX- Khu xay', 'BP.SX- Khu HBL', 'BP.cân PL', 'BP'];
	ngOnInit() {
		console.log(this.masterData)
		this.detailData = this.detailData.filter(x => x.TrangThaiChiTiet == false)

	}
	
	get_date_nhap_kho(){
		var date = new Date(this.masterData.NgayChuyen);
		return "Ngày "+("0" + date.getDate().toString()).slice(-2)+ "/"+ ("0" + (date.getMonth() + 1).toString()).slice(-2) + "/"+ date.getFullYear(); 
	}
	FormatDatetime(datetime) {
		return this.datePipe.transform(datetime, 'dd/MM/yyyy');
	}
	sum_so_luong(){
		// ;
		return this.detailData.length > 0 ? this.detailData.map(x => Number(x.KhoiLuongQuyDoi)).reduce((a, b) => a + b) : 0;
	}
	sum_so_luong_chung_tu(){
		// ;
		return this.detailData.length > 0 ? this.detailData.map(x => Number(x.Soluongchungtu)).reduce((a, b) => a + b) : 0;
	}
	getPhongBanDeNghi(){
		return this.detailData.length > 0 ? [...new Set(this.detailData.map(x => x.PhongBanDeNghi).filter(x => x !== ''))].join(', ') : '';
	}
	getLyDo(){
		return this.detailData.length > 0 ? [...new Set(this.detailData.map(x => x.LyDo).filter(x => x !== ''))].join(', ') : '';
	}
	checkLyDo(item: string){
		return this.masterData.LyDo.trim().toLowerCase() === item.trim().toLowerCase();
	}
	getSoPhieuDN(){
		const uniqueIds = new Set(this.detailData.map(x => x.IdDn));
		const uniqueSoPhieuDN = [];
		uniqueIds.forEach(id => {
			const found = this.detailData.find(x => x.IdDn === id);
			if (found) {
				uniqueSoPhieuDN.push(found.SoPhieuDN);
			}
		});
		return uniqueSoPhieuDN.join(', ');
	}
	get_date(){
		var date = new Date();
		return "Ngày "+("0" + date.getDate().toString()).slice(-2)+ "/"+ ("0" + (date.getMonth() + 1).toString()).slice(-2) + "/"+ date.getFullYear(); 
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}
	ChungTuKemTheo(item){
		if(item){
			return this.masterData.ChungTuKemTheo?'none':''
		}
		return this.masterData.ChungTuKemTheo?'':'none'
	}
}
